// extracted by mini-css-extract-plugin
export default {"content":"sN-z","lookName":"tN-z","shopTheLookContainer":"uN-z","productContainer":"vN-z","imageContainer":"wN-z","mainImage":"xN-z"};